import { Card, Button, Container, Row, Col, Carousel } from "react-bootstrap";
import { Heart, ShoppingCart } from "lucide-react";
import {Truck, RefreshCw, Leaf, ThumbsUp, Percent, Handshake } from "lucide-react";
import React, { useState } from 'react';
import Countdown from "react-countdown";
import "../Styles/TopDeals.css";
import DealsOfTheWeek from "./DealsOfTheWeek";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const products = [
  {
    id: 1,
    img: require("../Images/product1.png"),
    name: "Matihaat Spino45",
    category: "Insecticides",
    mrp: "₹1,600.00",
    discount: "53%",
    price: "₹749.00",
  },
  {
    id: 2,
    img: require("../Images/Fasal Amrit 1kg.png"),
    name: "Fasal Amrit",
    category: "Amendments, Conditioners, Fertilizers, Micro Nutrients",
    mrp: "₹999.00",
    discount: "10%",
    price: "₹899.00",
  },
  {
    id: 3,
    img: require("../Images/product3.jpg"),
    name: "Koppert Vici Routz SP",
    category: "Conditioners, Fertilizers",
    mrp: "₹405.00",
    discount: "11%",
    price: "₹369.00",
  },
  {
    id: 4,
    img: require("../Images/product4.png"),
    name: "T. Stanes Splendor 1ltr",
    category: "Fertilizers",
    mrp: "₹394.00",
    discount: "1%",
    price: "₹390.00",
  }
];



const reviews = [
    {
        name: "Nithin Reddy",
        review: "Amazing quality products! The organic fertilizers have really improved my crop yield.",
        photo: require("../Images/NithinN.png"),
        rating: 5,
    },
    {
      name: "Varshaa",
      review: "Great service and fast delivery. The insecticides are highly effective.",
      photo: require("../Images/varshaa.png"),
      rating: 4,
    },
    {
      name: "𝑨𝒓𝒈𝒉𝒂 𝑫𝒖𝒕𝒕𝒂",
      review: "Trusted brand for organic farming. Highly recommended!",
      photo: require("../Images/𝑨𝒓𝒈𝒉𝒂.png"),
      rating: 5,
    },
    {
      name: "Dr Vikas",
      review: "Excellent customer support and quality products!",
      photo: require("../Images/cikas.png"),
      rating: 4,
    },
    {
      name: "Anil Mehta",
      review: "Very satisfied with the product range and effectiveness!",
      rating: 5,
    },
    {
      name: "Priya Kapoor",
      review: "Affordable prices and great quality organic solutions.",
      rating: 4,
    },
    
  ];

const dealImages = [
  require("../Images/product1.png"),
//   require("../Images/deal2.png"),
  require("../Images/product3.jpg"),
//   require("../Images/deal4.png"),
//   require("../Images/deal5.png"),
];

export default function TopDeals({ handleCartClick, handleLikeClick , user}) {
  const [likedItems, setLikedItems] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();
  const toggleLike = (productId) => {
    setLikedItems((prevLiked) => {
      if (prevLiked.includes(productId)) {
        return prevLiked.filter((id) => id !== productId);
      } else {
        return [...prevLiked, productId];
      }
    });
  };

  const handleAddToCart = (product) => {
    if (!cartItems.includes(product.id)) {
      setCartItems((prev) => [...prev, product.id]); 
      handleCartClick(product);
    }
  };

  const handleImageClick = () => {
      navigate('/gpt');
  }

  return (
    <Container fluid className="top-deals-container text-center py-5">
      <h2 className="section-title mb-4">Featured Products</h2>
      <Row className="justify-content-center mt-3">
  {products.map((product) => {
    // Apply mobile-friendly column size based on device type
    const colClass = isMobile ? "col-6" : "col-12 col-sm-6 col-md-3"; // Show 2 items per row on mobile

    return (
      <Col key={product.id} className={`mb-4 ${colClass}`}>
      <Link to={`/product/${product.name}`} style={{ textDecoration: "none", color: "inherit" }}>
        <Card className="product-card shadow-lg mx-auto">
          <div className="discount-badge">{product.discount} OFF</div>
  
          <div className="d-flex justify-content-end">
            <Heart
              size={24}
              color={likedItems.includes(product.id) ? "red" : "gray"}
              className="cursor-pointer"
              onClick={(e) => {
                e.preventDefault(); // prevent card click when liking
                toggleLike(product.id);
                handleLikeClick(product);
              }}
            />
          </div>
  
          <Card.Img variant="top" src={product.img} className="product-image" />
  
          <Card.Body>
            <p className="product-category">{product.category}</p>
            <Card.Title className="product-title">{product.name}</Card.Title>
            <p className="product-mrp text-muted">
              <s>MRP: {product.mrp}</s>
            </p>
            <p className="product-price fw-bold">{product.price}</p>
  
            <Button 
              className="add-to-cart" 
              onClick={(e) => {
                e.preventDefault(); // prevent card click when adding to cart
                handleAddToCart(product);
              }}
              disabled={cartItems.includes(product.id)}
            >
              <ShoppingCart size={20} />{" "}
              {cartItems.includes(product.id) && user ? "Added to Cart" : "Add to Cart"}
            </Button>
          </Card.Body>
        </Card>
      </Link>
    </Col>
    );
  })}
</Row>

      <div className="helping-tree-container text-center mt-5">
        <h3 className="mb-3" id="nn">A HELPING TREE</h3>
        <img src={require("../Images/tree copy.png")} alt="Helping Tree" className="helping-tree" useMap="#tree-map" loading="lazy"/>
        <map name="tree-map">
          <area shape="rect" coords="50,50,150,150" href="#" alt="Category 1" />
          <area shape="rect" coords="200,50,300,150" href="#" alt="Category 2" />
          <area shape="rect" coords="350,50,450,150" href="#" alt="Category 3" />
        </map>
      </div>
      <DealsOfTheWeek handleCartClick={handleCartClick} handleLikeClick={handleLikeClick} />

      <img src={require("../Images/GPT.jpeg")} className="helping-tree" id="nith" useMap="#tree-map" loading="lazy" style={{cursor:"pointer"}} onClick={handleImageClick}/>
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="about-us-card shadow-lg p-4">
            <Card.Body>
              <h2 className="section-title">About Us</h2>
              <p className="lead">
                Mati Foods LLP was started by a group of organic farmers with a cumulative agriculture experience of over 50 years. We have farms in Delhi and Hyderabad and have been involved at various points in the organic food value chain. Over the years, we have researched the best inputs and sources for our own crops, and matihaat.com is a result of this accumulated knowledge.
              </p>
              <div className="video-container mt-4">
                <iframe
                  width="100%"
                  height= {isMobile?"150":"400"}
                  src="https://www.youtube.com/embed/fFm0gSsPIws"
                  title="About Mati Foods LLP"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <hr></hr>
      <Container fluid className="top-deals-container text-center py-5 bg-light">
      {/* Banner Section */}
      <div className="banner bg-success text-white py-4 mb-4">
        <h1 className="fw-bold">🔥 Exclusive Offers!</h1>
        <p>Get the best offers on organic farming products. Limited time only!</p>
      </div>

      {/* Offers Section */}
      <Row className="justify-content-center mb-4">
        {/* Banner 1 */}
        <Col className={`mb-3 ${isMobile ? 'col-6' : 'col-md-4'}`}>
          <Card className="banner-card shadow-lg text-center p-4 bg-primary text-white position-relative">
            <h4 className="nithin1">10% NOW OFF</h4>
            <p className="nithin">ACROSS ALL PRODUCTS</p>
            <div className="bg-success text-white py-3 px-3 w-100 position-absolute bottom-0 start-0 rounded-0">
              <strong>Use Code: MATI10</strong>
            </div>
          </Card>
        </Col>

        {/* Banner 2 */}
        <Col className={`mb-3 ${isMobile ? 'col-6' : 'col-md-4'}`}>
          <Card className="banner-card shadow-lg text-center p-4 bg-primary text-white position-relative">
            <h4 className="nithin1">SOIL TEST</h4>
            <p className="nithin"></p>
            <div className="bg-success text-white py-3 px-3 w-100 position-absolute bottom-0 start-0 rounded-0">
              <strong>₹500 ONLY</strong>
            </div>
          </Card>
        </Col>

        {/* Banner 3 */}
        <Col className={`mb-3 ${isMobile ? 'col-6' : 'col-md-4'}`} id="nnnm">
          <Card className="banner-card shadow-lg text-center p-4 bg-primary text-white position-relative">
            <h4 className="nithin1">15% NOW OFF</h4>
            <p className="nithin">ABOVE ₹5000</p>
            <div className="bg-success text-white py-3 px-3 w-100 position-absolute bottom-0 start-0 rounded-0">
              <strong>CHANGETHEWORLD</strong>
            </div>
          </Card>
        </Col>
      </Row>

      <div className="bg-success text-white text-center py-3 mb-4 rounded">
        <h5 className="mb-0">A UNIQUE RANGE OF MATIHAAT OWN PRODUCTS</h5>
      </div>
      
      <Row className="justify-content-center mb-5">
  <Col xs={6} md={2} className="text-center py-3">
    <ThumbsUp size={32} className="text-warning mb-2" aria-label="Best Deals on Organic Farming Products" />
    <p>Best Deals on Organic Farming Products</p>
  </Col>
  <Col xs={6} md={2} className="text-center py-3">
    <Truck size={32} className="text-info mb-2" aria-label="Free Shipping on Orders Above ₹300" />
    <p>Free Shipping on Orders Above ₹300</p>
  </Col>
  <Col xs={6} md={2} className="text-center py-3">
    <RefreshCw size={32} className="text-danger mb-2" aria-label="Free Returns Within 7 Days(T&CS Apply)" />
    <p>Free Returns Within 7 Days(T&CS Apply)</p>
  </Col>
  <Col xs={6} md={2} className="text-center py-3">
    <Leaf size={32} className="text-success mb-2" aria-label="Sustainable & Committed to Nature" />
    <p>Sustainable & Committed to Nature</p>
  </Col>
  <Col xs={6} md={2} className="text-center py-3">
    <Handshake size={32} className="text-primary mb-2" aria-label="We Support Monday-Saturday, 9 AM to 9 PM" />
    <p>We Support Monday-Saturday, 9 AM to 9 PM</p>
  </Col>
  <Col xs={6} md={2} className="text-center py-3">
    <Percent size={32} className="text-secondary mb-2" aria-label="Great Discounts on Bulk Orders" />
    <p>Great Discounts on Bulk Orders</p>
  </Col>
</Row>

      <hr></hr>
      </Container>
      <Container className="reviews-section py-5">
        <h2 className="section-title text-center mb-4">Customer Reviews</h2>
        <Carousel indicators={false} className="reviews-carousel" interval={4000}>
          {reviews.map((review, index) => (
            index % 3 === 0 && (
              <Carousel.Item key={index}>
                <Row className="justify-content-center">
                  {[0, 1, 2].map((offset) => (
                    reviews[index + offset] && (
                      <Col md={4} className="d-flex justify-content-center" key={index + offset}>
                        <Card className="review-card shadow-lg text-center p-4">
                          {reviews[index + offset].photo && (
                            <img src={reviews[index + offset].photo} alt={reviews[index + offset].name} className="customer-photo mb-3" loading="lazy"/>
                          )}
                          <Card.Body>
                            <h5 className="customer-name">{reviews[index + offset].name}</h5>
                            <p className="customer-review">"{reviews[index + offset].review}"</p>
                            <div className="customer-rating">
                              {Array(reviews[index + offset].rating).fill("★").join(" ")}
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    )
                  ))}
                </Row>
              </Carousel.Item>
            )
          ))}
        </Carousel>
        </Container>
        <footer className="text-center py-4 mt-5" style={{ backgroundColor: '#f8f9fa' }}>
      <Container>
        <Row className="justify-content-center align-items-center mb-3">
          <Col xs="auto" style={{color: "white"}}>
            <i className="bi bi-headset" style={{ fontSize: '2.5rem', color: '#a8cb41' }}></i>
          </Col>
          <Col xs="auto" className="text-start" style={{color: "white"}}>
            <p className="mb-1 fw-medium" style={{color: "white"}}>Got Questions? Call us 24/7!</p>
            <h5 className="fw-bold text-dark m-0">+91 9654870373</h5>
          </Col>
        </Row>

        <div className="mb-3" style={{color: "white"}}>
          <a href="https://www.facebook.com/people/Mati-Haat/61550736893804/" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="https://www.instagram.com/matihaat/" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4" style={{color: "white"}}>
            <i className="bi bi-instagram"></i>
          </a>
          <a href="https://www.youtube.com/@FarmingwithMatihaat" target="_blank" rel="noopener noreferrer" className="mx-2 text-dark fs-4" style={{color: "white"}}>
            <i className="bi bi-youtube"></i>
          </a>
        </div>

        <p className="text-muted mb-0 small" style={{color: "white"}}>© {new Date().getFullYear()} Mati Haat. All rights reserved.</p>
      </Container>
    </footer>     
    </Container>
  );
}